import React, { useEffect } from "react";
import { getRequest } from "@/services/http/http";
import { logger } from "@/utils";

type Consumer = React.Dispatch<React.SetStateAction<string>>;

const ImagesCache = new Map<string, string>();

export const useAvatarLoader = (url: string, callback: Consumer) => {
  useEffect(() => {
    if (!url) {
      return;
    }

    let resultUrl = "";
    const cachedImage = ImagesCache.get(url);

    if (cachedImage) {
      callback(cachedImage);
    }

    const controller = new AbortController();

    getRequest<BlobPart>(url, undefined, {
      responseType: "blob",
      signal: controller.signal,
    })
      .then(data => {
        const blob = new Blob([data]);

        resultUrl = URL.createObjectURL(blob);
        ImagesCache.set(url, resultUrl);
        callback(resultUrl);
      })
      .catch(logger.warning);

    return () => {
      controller.abort();

      if (resultUrl) {
        URL.revokeObjectURL(resultUrl);
      }
    };
  }, [url, callback]);
};
